import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StatisticsConfigurationApiService {

  constructor(private http: HttpClient) { }

  private readonly callsConfigurationUrl: string = 'configuration/statistics';

  public getStatisticsConfiguration(): Observable<any> {
    return this.http.get(this.callsConfigurationUrl);
  }

  public editStatisticsConfiguration(callsConfiguration): Observable<any> {
    return this.http.put(this.callsConfigurationUrl, callsConfiguration);
  }
}
